<template>
    <div>
        <psi-page-title
            :title="page.title"
            :icon="page.icon"
            :breadcrumbs="pageBreadcrumbs"
        >
        </psi-page-title>

        <!-- Content always starts with a v-card  -->
        <v-card class="mt-4">
            <v-card-text>
                <psi-toolbar
                    title="Instructors"
                    :filters="[]"
                    :quicklinks="[]"
                    :actions="[]"
                    :view-option.sync="viewOption"
                    hide-view-options
                    @refresh="refresh"
                    close-on-select
                    close-on-clear
                >
                </psi-toolbar>
                <v-row>
                    <v-spacer></v-spacer>
                    <psi-form-text-field
                        id="search"
                        name="search"
                        :value="search"
                        class="mt-4 mr-3"
                        style="max-width: 450px"
                        :dark="false"
                        label="Search"
                        clearable
                        autofocus
                        placeholder="Search by instructor name or email"
                        icon="mdi-magnify"
                        @input="debounceHandler"
                    />
                </v-row>
                <program-paginator
                    v-if="programInstructors.to"
                    :per_page.sync="per_page"
                    :current_page.sync="current_page"
                    :total_pages="programInstructors.last_page"
                    :to="programInstructors.to"
                    :from="programInstructors.from"
                    :total="programInstructors.total"
                />
                <keep-alive>
                    <component
                        :loading="dataLoading"
                        :instructors="$_.get(programInstructors, 'data', [])"
                        :is="`instructor-${viewOption}`"
                        @action="instructorAction"
                    ></component>
                </keep-alive>
            </v-card-text>
        </v-card>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import HomeLink from "@/mixins/homelink";
import debounce from "lodash.debounce";

export default {
    name: "program-instructors",
    mixins: [HomeLink],
    components: {
        InstructorList: () =>
            import("@components/program/components/ProgramInstructorList"),
        ProgramPaginator: () =>
            import("@components/program/components/ProgramPaginator"),
    },
    data() {
        return {
            page: {
                title: "Rent Well Instructors",
                icon: "mdi-school",
            },
            filters: [],
            quicklinks: [],
            selectedItems: [],
            search: "",
            viewOption: this.$vuetify.breakpoint.mobile ? "grid" : "list",
            per_page: this.$config("program.pagination.perPage"),
            current_page: 1, // start on page 1
        };
    },
    computed: {
        ...mapGetters("Programs", ["programInstructors", "dataLoading"]),
        pageBreadcrumbs() {
            return [
                Object.assign(
                    {
                        text: "Home",
                        disabled: false,
                    },
                    this.homeUrl
                ),
                {
                    text: "Instructors",
                    disabled: true,
                    to: "#",
                },
            ];
        },
    },
    methods: {
        ...mapActions("Programs", [
            "getProgramInstructors",
            "resendInstructorInvite",
        ]),
        getParams() {
            return this.search
                ? {
                      current_page: this.current_page,
                      per_page: this.per_page,
                      search: this.search,
                  }
                : {
                      current_page: this.current_page,
                      per_page: this.per_page,
                  };
        },
        refresh() {
            this.getProgramInstructors(this.getParams());
        },
        onSearch(term) {
            this.search = term;
            if (
                this.search === null ||
                this.search.length > 2 ||
                this.search.length === 0
            ) {
                this.refresh();
            }
        },
        instructorAction(id, item) {
            console.log("Action event with id = %s, action = %o", id, item);
            const instructor = this.programInstructors.data.find(
                (instructor) => instructor.id === id
            );

            const query = {
                instructorId: instructor.id,
                programId: instructor.programId,
            };

            switch (item.name) {
                case "view-dashboard":
                    this.$router.push({
                        path: "/programs/instructor/dashboard",
                        query,
                    });
                    break;
                case "resend-instructor-invite":
                    this.resendInstructorInvite(instructor.id);
                    break;
            }
        },
    },
    watch: {
        current_page() {
            this.refresh();
        },
        per_page() {
            // start at page 1 when changing per page counts
            this.current_page = 1;
            this.refresh();
        },
    },
    mounted() {
        this.refresh();
    },
    created() {
        this.debounceHandler = debounce((term) => {
            this.onSearch(term);
        }, 200);
    },
    beforeUnmount() {
        this.debouncedHandler.cancel();
    },
};
</script>

<style scoped>
</style>